// 不需要authToken的接口
const noNeedAuthList = [
  '/api/main/login',
  '/api/system/account/send_code',
  '/api/common/captcha/get',
  '/api/common/captcha/check',
  '/api/system/account/apply_trial',
];

/**
 * 是否需要添加authToken
 */
export function hasAuthToken(path) {
  return !noNeedAuthList.find(item => path.endsWith(item));
}